document.addEventListener("DOMContentLoaded", function () {
  var targetURLs = [
    "https://www.hairoriginals.com/pages/try-at-home-new",
    "https://www.hairoriginals.com/pages/video-call",
    "https://www.hairoriginals.com/pages/permanent-extensions-new",
    "https://www.hairoriginals.com/pages/men-patch-new",
    "https://www.hairoriginals.com/pages/get-in-touch",
    "https://www.hairoriginals.com/pages/india-lead-gen",
    "https://www.hairoriginals.com/pages/b2b-partnership",
    "https://www.hairoriginals.com/pages/hair-originals-experience-center-gurgaon",
    "https://www.hairoriginals.com/pages/hair-originals-experience-center-hyderabad",
    "https://www.hairoriginals.com/pages/hair-originals-experience-center-bangalore",
    "https://www.hairoriginals.com/pages/hair-originals-experience-center-delhi-ncr",
    "https://www.hairoriginals.com/pages/mumbai-lead",
    "https://www.hairoriginals.com/pages/indian-lead-gen",
    "https://www.hairoriginals.com/pages/permanent-extensions-home-trial",
  ];

  if (targetURLs.includes(window.location.href.split("?")[0].split("#")[0])) {
    var observer = new MutationObserver(function (mutationsList, observer) {
      var popup = document.querySelector(".qr-optin-pop");
      if (popup) {
        popup.remove();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    var existingPopup = document.querySelector(".qr-optin-pop");
    if (existingPopup) {
      existingPopup.remove();
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let today = new Date();
  let year = today.getFullYear();
  let month = String(today.getMonth() + 1).padStart(2, "0");
  let day = String(today.getDate()).padStart(2, "0");

  let minDate = `${year}-${month}-${day}`;

  document.getElementById("txtDate").setAttribute("min", minDate);
});

// ==========  TRY AT HOME Video call remove ========

const tryAtHomeUrl = [
  "https://www.hairoriginals.com/products/forehead-patch",
  "https://www.hairoriginals.com/products/mini-scalp-topper-smallest-scalp-topper-1-5-3",
  "https://www.hairoriginals.com/products/invisible-patch",
  "https://www.hairoriginals.com/products/thick-hair-patch",
  "https://www.hairoriginals.com/products/hair-fiber",
  "https://www.hairoriginals.com/products/hair-powder",
  "https://www.hairoriginals.com/products/frame-my-face",
  "https://www.hairoriginals.com/products/remy-human-hair-scrunchie",
  "https://www.hairoriginals.com/products/layered-one-clip-give-me-more-layers-hair-extensions",
  "https://www.hairoriginals.com/products/one-clip-extension-hair-extensions",
  "https://www.hairoriginals.com/products/open-scrunchie",
  "https://www.hairoriginals.com/products/human-hair-string-donut-bun",
  "https://www.hairoriginals.com/products/hot-knot-hair-bun",
  "https://www.hairoriginals.com/products/low-density-messy-bun",
  "https://www.hairoriginals.com/products/curly-donut-bun",
  "https://www.hairoriginals.com/products/curly-top-knot",
  "https://www.hairoriginals.com/products/bangs-100-original-human-hair-easy-to-use-fix-with-clips",
  "https://www.hairoriginals.com/products/bangs-for-kids",
  "https://www.hairoriginals.com/products/bangs-without-temple",
  "https://www.hairoriginals.com/products/clip-in-hair-streaks-100-human-coloured-hair-extension",
  "https://www.hairoriginals.com/products/balayage-streaks",
  "https://www.hairoriginals.com/products/streaks-for-kids",
  "https://www.hairoriginals.com/products/clip-in-hair-streaks-colored-hair-extensions-for-women-highlighter-sale",
  "https://www.hairoriginals.com/products/silver-crown-messy-bun-scrunchie",
  "https://www.hairoriginals.com/products/one-clip-hair-extensions-women-highlighter",
  "https://www.hairoriginals.com/products/clip-in-hair-streaks-100-human-coloured-hair-extension",
  "https://www.hairoriginals.com/products/balayage-streaks",
  "https://www.hairoriginals.com/products/clip-in-hair-streaks-pack-of-2-colored-hair-extensions-for-women-highlighter",
  "https://www.hairoriginals.com/products/eyebrow-shaper-enhancer-for-denser-fuller-eyebrows",
  "https://www.hairoriginals.com/products/hair-fiber-applicator",
  "https://www.hairoriginals.com/products/applicator",
  "https://www.hairoriginals.com/products/linen-bow",
  "https://www.hairoriginals.com/products/butterfly-bow",
  "https://www.hairoriginals.com/products/bows-and-scrunchies",
  "https://www.hairoriginals.com/products/treasure-box",
  "https://www.hairoriginals.com/products/pretty-pearl-clip",
  "https://www.hairoriginals.com/products/emerald-pearl-clip",
  "https://www.hairoriginals.com/products/500-piece-nano-ring-for-extension-original-hair-extensions",
  "https://www.hairoriginals.com/products/500-pc-micro-ring-for-extension-original-hair-extensions",
  "https://www.hairoriginals.com/products/hair-extensions-pliers-original-hair-extensions",
  "https://www.hairoriginals.com/products/hair-extension-clips",
];

const currentUrl = window.location.href.split("?")[0].replace(/\/$/, "");

if (tryAtHomeUrl.includes(currentUrl)) {
  $(".try-home-bx").remove();
  $(".prd-box1").remove();
}

const specialProductUrl =
  "https://www.hairoriginals.com/products/clip-in-hair-streaks-colored-hair-extensions-for-women-highlighter-sale";

if (currentUrl === specialProductUrl) {
  $(".two-bx-vd").remove();
}
setTimeout(function () {
  $(".globo-swatch-list .swatch--gl")
    .first()
    .find("ul")
    .append(
      $('<li class="select-option globo-sold-out-hide available"></li>').append(
        $(".myBtn4")
      )
    );
}, 2000);

// <!-- PRE ORDER CREATE ======= -->

$(function () {
  var d = new Date(),
    m = d.getMonth() + 1,
    day = d.getDate(),
    y = d.getFullYear();
  if (m < 10) m = "0" + m;
  if (day < 10) day = "0" + day;
  $("#txtDate").attr("min", y + "-" + m + "-" + day);
});

const preOrderVariants = ["" , "53527512219939" , "" , "53527550984483"  , "53527512154403" , "53527551017251" , "53527551050019", "53527512154403" , "53527551082787" , "53527551115555" , "53527551148323" , ""];

function updatePreOrderStatus(id) { 
  const isPreOrder = preOrderVariants.includes(id?.toString());

  const interval = setInterval(() => {
    const $btn = $('form[action="/cart/add"] button span');
    const $preOrderLine = $(".pre-order-line");

    if ($btn.length && $preOrderLine.length) {
      if (isPreOrder) {
        $btn.text("Pre Order");
        $preOrderLine.show();
      } else {
        $btn.text("Add to Cart");
        $preOrderLine.hide();
      }
      clearInterval(interval);
    }
  }, 100);
}

let currentVariantId = null;

if (typeof Shopify !== "undefined" && Shopify.product?.variants) {
  const defVar = Shopify.product.variants.find((v) => v.available);
  currentVariantId = defVar?.id?.toString();
  updatePreOrderStatus(currentVariantId);
}

document.addEventListener("variant:change", function (e) {
  const newId = e.detail?.variant?.id?.toString();
  if (newId) updatePreOrderStatus(newId);
});

const observer = new MutationObserver(() => {
  const input = document.querySelector('input[name="id"]');
  if (input && input.value !== currentVariantId) {
    currentVariantId = input.value;
    updatePreOrderStatus(currentVariantId);
  }
});

observer.observe(document.body, { childList: true, subtree: true });

observer.observe(document.body, { childList: true, subtree: true });

// <!-- PRE ORDER CREATE END ======= -->

// ===== PRE ODER - OLD Am =======

// SEARCH PAGE ENTER =======

document.addEventListener("DOMContentLoaded", function () {
  const e = document.querySelector('form[action="/search"]'),
    t = document.querySelector('input[name="q"]'),
    r = [
      {
        k: [
          "try at home",
          "men patch trial",
          "men try at home",
          "men trial",
          "men patch home trial",
          "try men patch at home trial",
        ],
        u: "/pages/try-men-patch-at-home-trial",
      },
      { k: ["hair extensions"], u: "/products/hair-extensions" },
      { k: ["volume topper"], u: "/products/volume-hair-topper" },
      {
        k: [
          "permanent extensions trial",
          "permanent extensions try at home",
          "permanent extensions home trial",
        ],
        u: "/pages/permanent-extensions-home-trial",
      },
      {
        k: ["b2b partnership", "partnership", "b2b"],
        u: "/pages/b2b-partnership",
      },
    ];
  e &&
    t &&
    e.addEventListener("submit", function (n) {
      const o = t.value.trim().toLowerCase();
      for (const e of r)
        if (e.k.includes(o)) {
          n.preventDefault(), (window.location.href = e.u);
          break;
        }
    });
});


// ====== hide page in search bar =======





document.addEventListener("DOMContentLoaded", function () {
  const announcementBar = document.querySelector(".announcement-bar-ctm");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 0) {
      announcementBar.style.position = "fixed";
      announcementBar.style.top = "0";
      announcementBar.style.width = "100%";
      announcementBar.style.zIndex = "1";
    } else {
      announcementBar.style.position = "relative";
    }
  });
});

// Choose Option problem
window.addEventListener("load", function () {
  (function () {
    if (!Array.prototype.__patchedSome) {
      const originalSome = Array.prototype.some;

      Array.prototype.some = function (callback, thisArg) {
        return originalSome.call(
          this,
          function (item, index, array) {
            try {
              return callback.call(thisArg, item, index, array);
            } catch (e) {
              if (
                e instanceof TypeError &&
                typeof e.message === "string" &&
                e.message.includes("includes is not a function")
              ) {
                console.warn(
                  "[Patch] Handled TypeError in .some():",
                  e.message
                );
                return false;
              }
              throw e;
            }
          },
          thisArg
        );
      };

      Array.prototype.__patchedSome = true;
    }
  })();
});


document.addEventListener("DOMContentLoaded", () => {
  const path = window.location.pathname,
    widgetPages = [
      "/pages/try-at-home-new",
      "/pages/video-call",
      "/pages/try-men-patch-at-home-trial",
      "/pages/permanent-extensions-home-trial",
      "/pages/b2b-partnership",
      "/pages/get-in-touch",
      "/pages/permanent-extensions-new",
      "/pages/india-lead-gen",
    ],
    shouldRemoveWidget =
      path.startsWith("/products/") || widgetPages.includes(path);
  if (!shouldRemoveWidget) return;

  const observer = new MutationObserver(() => {
    document
      .querySelectorAll(".nector-websdk-widget")
      .forEach((el) => el.remove());
    console.log("✅ Widget force removed");
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener("beforeunload", () => observer.disconnect());

  const iframeInterval = setInterval(() => {
    document.querySelectorAll("iframe").forEach((el) => {
      if (
        (el.src && el.src.includes("nector")) ||
        (el.className && el.className.includes("nector"))
      ) {
        el.remove();
        console.log("✅ Nector iframe removed");
      }
    });
  }, 500);
  setTimeout(() => clearInterval(iframeInterval), 25000);
});

// time slot hide

document.addEventListener("DOMContentLoaded", function () {
  const e = document.querySelector('select[name="time"]'),
    t = document.getElementById("txtDate");

  function n() {
    const options = e.querySelectorAll("option"),
      selectedDateStr = t.value,
      selectedDate = selectedDateStr ? new Date(selectedDateStr) : new Date(),
      now = new Date(),
      isToday = selectedDate.toDateString() === now.toDateString();

    // Set threshold time (current time + 1 hour)
    const threshold = new Date(now.getTime() + 60 * 60 * 1000);

    options.forEach((option, index) => {
      if (index === 0) return; // Skip first placeholder option
      option.disabled = false;

      const timeRange = option.textContent.trim().split(" - ");
      if (timeRange.length !== 2) return;

      const timeMatch = timeRange[1].match(/(\d+):(\d+)\s?(AM|PM)/i);
      if (!timeMatch || timeMatch.length < 4) return;

      let hour = parseInt(timeMatch[1], 10),
        minute = parseInt(timeMatch[2], 10),
        period = timeMatch[3].toUpperCase();

      if (period === "PM" && hour !== 12) hour += 12;
      if (period === "AM" && hour === 12) hour = 0;

      const endTime = new Date(selectedDate);
      endTime.setHours(hour, minute, 0, 0);

      // Disable if selected date is today and endTime is within 1 hour from now
      if (isToday && endTime <= threshold) {
        option.disabled = true;
      }
    });
  }

  t.addEventListener("change", n);
  n();
});

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.pathname;

  // All collections where button must be hidden
  const hiddenCollections = [
    "/collections/bangs-1",
    "/collections/buns-1",
    "/collections/ponytail",
    "/collections/scalp-topper-1",
    "/collections/volumizers-amp-clip-sets-1",
    "/collections/side-patches",
    "/collections/wigs",
    "/collections/permanent-hair-extensions",
    "/collections/shop-for-women",
    "/collections/streaks",
  ];

  if (hiddenCollections.includes(currentUrl)) {
    const style = document.createElement("style");
    style.innerHTML = `
        .dark-brown.myBtn2 {
          display: none !important;
        }
      `;
    document.head.appendChild(style);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const prices = document.querySelectorAll(".money");

  prices.forEach(function (priceElement) {
    const text = priceElement.textContent.trim();

    // Remove `.00` only from the end of prices
    const updated = text.replace(/\.00\b/g, "");

    // Update text only if it changed
    if (updated !== text) {
      priceElement.textContent = updated;
    }
  });
});





document.addEventListener("DOMContentLoaded", () => {
  // ✅ 1. Variant-based IDs
  const ids = new Set([
    "46161264410915", "52529929093411", "52529929060643", "46743081877795",
    "", "", "49857509949731", "46743081746723",
    "49857509916963", "49857510048035", "49857510015267", "49857509884195",
    "", "49857509982499", "", "53657160253731",
    "", "48481755726115", "48481755988259", "",
    "48481756512547", "48481756774691", "48481757036835", "",
    "", "48481755595043", "48481755857187", "",
    "48481756381475", "48481756643619", "48481756905763", "",
    "53657160286499", "53657160319267", "53657160352035", "53657160384803",
    "53657160417571", "48481755496739", "48481755758883", "48481756021027",
    "48481756283171", "48481756545315", "48481756807459", "48481757069603",
    "48481757331747", "48481757397283", "48481757135139", "48481756872995",
    "48481756610851", "48481756348707", "48481756086563", "48481755824419",
    "48481755562275", "53268549304611", "", "53657160057123",
    "48481757266211", "", "48481757200675", "46179090268451",
    "46179090301219", "46179083485475", "46179083551011", "46179088040227",
    "46179088007459" , "46161264476451"
  ]);

  // ✅ 2. Product name-based
  const productNames = [
    // "Highlighted Scalp Topper Hair Extensions| Hide Hair Thinning For Scalp Area",
    // "Small Scalp Topper Hair Extensions For Women | Silk base & 100% Human Hair"
  ];

  // ✅ 3. Handle-based
  const productHandles = [
    // "scalp-topper-with-highlights",
  ];

  // ✅ 4. Variant identifiers (SKU/Title/Options match list)
  const variantKeys = new Set([
    // "ST/16/Natural_Black/NT/4x2",
    // "ST/18/Natural_Black/NT/4x2",
    "ST/14/Natural_Black/NT/5x3",
    "SFT/14/Natural_Black/NT/5x3",
    // "ST/12/Natural_Black/NT/5x3",
    "ST/14/Natural_Black/NT/6x2",
    // "ST/20/Natural_Black/NT/4x2",
    "ST/16/Natural_Brown/NT/4x2",
    "ST/20/Natural_Brown/NT/4x2",
    "ST/22/Natural_Black/NT/4x2",
    "ST/18/Natural_Brown/NT/4x2",
    "ST/14/Natural_Black/NT/2x3",
    "ST/14/Natural_Brown/NT/2x3",
    // "ST/12/Natural_Brown/NT/5x3",
    "ST/14/Natural_Brown/NT/5x3",
    "ST/14/Natural_Brown/NT/6x2",
    "SFT/14/Natural_Brown/NT/5x3",
    // "ST/12/Natural_Black/NT/6x2",
    // "ST/12/Natural_Brown/NT/6x2",
    "ST/22/Natural_Brown/NT/4x2",
    "ST/20/Jet_Black/NT/2x4",
    // "SFT/16/Natural_Black/NT/4x2",
    "SFT/18/Natural_Black/NT/4x2",
    // "SFT/20/Natural_Black/NT/4x2",
    "SFT/22/Natural_Black/NT/4x2",
    // "SFT/16/Natural_Brown/NT/4x2",
    "SFT/18/Natural_Brown/NT/4x2",
    // "SFT/20/Natural_Brown/NT/4x2",
    "SFT/22/Natural_Brown/NT/4x2"
  ]);

  const box = document.querySelector(".f-product-form__buttons.f-product-form__buttons--show-buynow");
  const btn = document.getElementById("notifyMeBtn");
  const popup = document.getElementById("notifyPopup");

  const getHandle = () => {
    const h = window.meta?.product?.handle;
    if (h) return h;
    const parts = window.location.pathname.split("/products/");
    return parts[1] ? parts[1].split("/")[0] : "";
  };

  const update = () => {
    const vid = document.querySelector('[name="id"]')?.value;
    const product = window.meta?.product;
    const v = product?.variants?.find(x => String(x.id) === String(vid));

    // ✅ Condition 1: Variant ID + OOS
    const matchById = ids.has(String(vid)) && !v?.available;

    // ✅ Condition 2: Product name OR handle
    const matchByName = productNames.includes(product?.title || "");
    const matchByHandle = productHandles.includes(getHandle());

    // ✅ Condition 3: Variant SKU/Title/Options match
    let variantKeyMatch = false;
    if (v) {
      if (variantKeys.has(v.sku)) variantKeyMatch = true;        // SKU check
      else if (variantKeys.has(v.title)) variantKeyMatch = true; // Title check
      else {
        // option1/option2/option3 join check
        const optString = [v.option1, v.option2, v.option3].filter(Boolean).join("/");
        if (variantKeys.has(optString)) variantKeyMatch = true;
      }
    }
    const matchByVariantKey = variantKeyMatch && !v?.available;

    // ✅ Final decision
    const showNotify = matchById || matchByName || matchByHandle || matchByVariantKey;

    if (showNotify) {
      box.style.display = "none";
      btn.style.display = "block";

      // 🔥 EXTRA: Hide sticky ATC buttons
      document.querySelectorAll(".sticky-atc-bar__inner .f-product-form__buttons")
        .forEach(el => el.style.display = "none");

    } else {
      box.style.display = "";
      btn.style.display = "none";
      popup?.classList.remove("show");

      // 🔥 EXTRA: Show sticky ATC buttons back
      document.querySelectorAll(".sticky-atc-bar__inner .f-product-form__buttons")
        .forEach(el => el.style.display = "");
    }
  };

  // ✅ Event Listeners
  document.querySelectorAll('[name="id"]').forEach(el => el.addEventListener("change", update));
  btn?.addEventListener("click", () => popup?.classList.add("show"));
  popup?.addEventListener("click", e => {
    if (e.target.classList.contains("close-popup")) popup.classList.remove("show");
  });

  update();
});






function allowSwiperOnVideoSlides() {
  // All deferred-media blocks
  document.querySelectorAll('.deferred-media, .deferred-media__poster, .deferred-media video').forEach(el => {
    el.style.pointerEvents = 'none';
    el.style.userSelect = 'none';
    el.style.cursor = 'grab';
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', allowSwiperOnVideoSlides);

// Run on Flickity slide change
document.addEventListener('shopify:section:load', allowSwiperOnVideoSlides);
// In case video loads after AJAX
setTimeout(allowSwiperOnVideoSlides, 1000);



// =========  custimiztion leanth =====

    document.addEventListener("DOMContentLoaded", function () {
  const variantContainer = document.querySelector(".variant-picker__option-values");
  const existingBtn = document.querySelector(".row .myBtn3");

  if (variantContainer && existingBtn) {
    variantContainer.appendChild(existingBtn); 
  }
});

// ======= get in touch form ======

document.addEventListener("DOMContentLoaded",()=>{
  const f=document.querySelector("#ajax-form7");
  if(!f) return;
  const p=f.querySelector('[name="shopify_product"]'),
        l=f.querySelector('[name="location"]'),
        loc={
          mp:["Delhi NCR","Hyderabad","Others"],
          pe:["Delhi NCR","Kolkata","Chennai","Mumbai","Hyderabad","Others"],
          df:["Delhi","Gurgaon","Ghaziabad","Faridabad","Noida","Greater Noida","Mumbai","Hyderabad" , "Others"]
        },
        set=o=>{
          l.innerHTML='<option value="" disabled selected style="display:none;">Select the location ...</option>';
          o.forEach(c=>l.innerHTML+=`<option>${c}</option>`);
        };
  p.addEventListener("change",()=>{
    const v=p.value.toLowerCase();
    set(v.includes("men")?loc.mp:v.includes("permanent")?loc.pe:loc.df);
  });
});


// ============  products sale strip basge  ======


